import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withSizes from 'react-sizes';

import { H, Body, Small } from 'deltoid/core/Blocks/Typography';
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import Form from 'deltoid/core/Form';
import DropUploader from 'deltoid/core/DropUploader';
import SingleFileUploader from '@components/BaseComponents/SingleFileUploader';
import Uploader from '@components/BaseComponents/Uploader';
import ActionCableConsumer from '@components/BaseComponents/ActionCableConsumer';
import List from '@components/BaseComponents/List';
import AuthManager from '@services/AuthManager';
import { OCR_VALIDATIONS_PLACEHOLDER, BANK_PROOF_DOC_TYPES } from '@constants/bankConstants';


import {
  dialogActions, merchantSelectors,
  bankDetailsActions, bankDetailsSelectors,
  masterDataSelectors, bankDetailsActionTypes,
  uiActions, toastActions,
} from '@store/ducks';

const UploadDocument = ({
  openLoader,
  closeDialog,
  merchantDetails,
  isMobile,
  uploadBankProof,
  categoryTypes,
  documentTypes,
  getUploadProcessing: getUploadProcessingProp,
  loadUI,
  resetUploadBankProof,
  showToast,
}) => {
  const [previewFile, setPreviewFile] = useState();
  const [docType, setDocType] = useState(BANK_PROOF_DOC_TYPES[0]);
  const [err, setError] = useState(false);
  const [ocrErr, setOcrError] = useState(false);
  const [validationList, setValidationList] = useState(false);
  const [getUploadProcessing, setUploadProcessing] = useState(getUploadProcessingProp);
  const { pancard_name, bank_detail } = merchantDetails || {};
  const { bank_account_number, holder_name } = bank_detail || {};

  useEffect(() => setUploadProcessing(getUploadProcessingProp), [getUploadProcessingProp]);

  const handleDocAccepted = ([file]) => {
    setError(false);
    setOcrError(false);
    setValidationList(false)
    setPreviewFile(file)
  }

  const handleDocRejection = (fileError) => {
    const errMsg = fileError?.[0]?.errors?.[0]?.message;
    setOcrError(false);
    setValidationList(false)
    if (errMsg)
      setError(errMsg);
  };

  const handleRemoveFile = () => {
    setPreviewFile(null)
    setError(false);
    setOcrError(false);
  };

  const handleSubmit = () => {
    if (!previewFile) {
      !err && setError('Please upload a valid the file');
      return;
    }
    console.log(previewFile);
    let formData = new FormData();
    formData.append('processed_document', previewFile);
    formData.append(
      'document_type_id',
      documentTypes[docType.value] ? documentTypes[docType.value].id : 0,
    );
    uploadBankProof(formData, docType.value);
  };

  const handleWebsocket = (m) => {
    if (m && m.ocr_response) {
      const { ocr_response: { result }, error_msg } = m;
      const { name, accNo, ifsc } = result || {};
      let errList = [];
      errList = errList.concat({
        type: (name && name.length) ? 'valid' : 'invalid',
        content: `Name ${(name && name.length) ? '' : 'not'} found on document`,
      });
      errList = errList.concat({
        type: accNo ? 'valid' : 'invalid', content: `Account Number ${accNo ? '' : 'not'} found on document`
      });
      errList = errList.concat({
        type: ifsc ? 'valid' : 'invalid', content: `IFSC ${ifsc ? '' : 'not'} found on document`
      });
      setValidationList(errList);
      if (error_msg) {
        setOcrError(error_msg);
        setUploadProcessing(false);
      } else {
        openLoader();
      }
      resetUploadBankProof();
    }
  }
  return (
    <div className='d-flex flex-column' data-testid='bank-proof-upload'>
      {AuthManager.getMerchantUUID() && <ActionCableConsumer
        channelName='ProfileChannel'
        identifier={AuthManager.getMerchantUUID()}
        action={handleWebsocket}
      />}
      {
        !isMobile && (
        <div className='co-bg-yellow-tint p-3 w-100'>
          <div className='bg-white border rounded p-3'>
            <Body className='pb-2'>
              Your bank account must be in the name of:
              {' '}<strong>{holder_name || pancard_name}</strong>
            </Body>
            <Small>
              A/C Number: {bank_account_number}<br/>
              The name on this bank account doesn’t match the name on your PAN<br/>
              <Form.Button
                onClick={() => closeDialog()}
                variant="underlined"
                type="button"
                className='p-0'
              >
                Re-enter Bank Details
              </Form.Button>
            </Small>
          </div>
        </div>
      )}
      <div className='w-100'>
        <H level={5} className='text-center pb-1 pt-3 pl-2 pr-2' variant='bold'>
          Upload {docType.label} for proof
        </H>
        <Small className='text-center pb-3 d-block pl-2 pr-2'>
          Make sure the name on document match the name on your PAN you have given us
        </Small>
      </div>
      <Row className='ml-4 mr-4'>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Bank Proof</Form.Label>
            <Form.Select
              options={BANK_PROOF_DOC_TYPES}
              placeholder='select the proof type.'
              defaultValue={BANK_PROOF_DOC_TYPES[0]}
              onChange={(v) => { setDocType(v); setError(false); handleRemoveFile(); }}
              menuPlacement={['BS', 'PB'].includes(docType.value) && !isMobile ? 'top' : 'bottom'}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Upload Photo</Form.Label>
            <SingleFileUploader
              allowedFileExtensions="image/png, application/pdf, image/jpg, image/jpeg"
              maxFileSizeInMB={5}
              onFileDropAccepted={handleDocAccepted}
              onFileDropRejected={handleDocRejection}
              handleRemoveFile={handleRemoveFile}
              placeholder='Upload Document'
              uploaderState={err ? 'uploadError' : (previewFile ? 'uploaded' : null)}
              uploadedDocument={previewFile}
            />
            { err
              ? <Form.Message type='error'>{err}</Form.Message>
              : <Form.Message>Maximum Upload should be 5MB</Form.Message>
            }
          </Form.Group>
        </Col>
      </Row>
      <Row className='ml-4 mr-4 mb-1'>
        <Col>
          {ocrErr && (<Form.Message type='error' className='mb-2 mr-2 d-inline'>{ocrErr}</Form.Message>)}
          { ocrErr && validationList && (
            <Uploader
              onFileDropAccepted={handleDocAccepted}
              onFileDropRejected={handleDocRejection}
              handleRemoveFile={handleRemoveFile}
              allowedFileExtensions={"image/png, application/pdf, image/jpg, image/jpeg"}
              maxFileSizeInMB={5}
              label='Reupload'
            />
          )}
        </Col>
      </Row>
      {
        !['BS', 'PB'].includes(docType.value) && (
        <Row className='ml-4 mr-4 mb-3'>
          <Col md={5}>
            <img
              src={previewFile ? URL.createObjectURL(previewFile) : '../../../../assets/images/cheque-illustration.svg' }
              className={`uploaded-img-preview mb-2 ${err && validationList ? 'error' : ''}`}
            />
          </Col>
          <Col md={7} className='pl-3 pr-3'>
            <List
              data={
                validationList
                ? validationList
                : OCR_VALIDATIONS_PLACEHOLDER.map((v) => ({ type: 'valid', content: v }))
              }
            />
          </Col>
        </Row>
      )}
      <Row noGutters className='flex-row-reverse p-3 bg-light'>
        { ocrErr && validationList ? (
          <Form.Button
            type='button'
            onClick={() => {
              closeDialog(bankDetailsActionTypes.resetUploadBankProof);
              loadUI({ bank_detail: { ...bank_detail, bank_verification_proof: 'CC', bank_verification_status: 'Pending' }});
              showToast({ variant: 'warning', title: 'Proof Submitted sucessfully!', content: 'Bank details proof received. We will verify it within the next 24-48 hours.' });
            }}
            className='mr-3 my-auto'
          >
            Submit for Manual Verification
          </Form.Button>
        ) : (
          <Form.Button type='button' onClick={handleSubmit} disabled={getUploadProcessing}
            loading={getUploadProcessing}
          >
            {getUploadProcessing ? 'Verifying...' : 'Submit for Verification'}
          </Form.Button>
        )}
      </Row>
    </div>
  )
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});

const Responsive = withSizes(mapSizesToProps)(UploadDocument);

const mapDispatchToProps = dispatch => ({
  openConfirmation: () => dispatch(dialogActions.open('bank-confirmation')),
  openDocUpload: () => dispatch(dialogActions.open('bank-doc-upload')),
  openLoader: () => dispatch(dialogActions.open('bank-ws-loader')),
  closeDialog: () => dispatch(dialogActions.close()),
  uploadBankProof: (formData, docType) =>
    dispatch(bankDetailsActions.uploadBankProof(formData, docType)),
  loadUI: (details) => dispatch(uiActions.loadUI(details)),
  resetUploadBankProof: () => dispatch(bankDetailsActions.resetUploadBankProof()),
  showToast: (toastProps) => dispatch(toastActions.show(toastProps)),
});

const mapStateToProps = (state) => ({
  merchantDetails: merchantSelectors.getMerchantDetails(state),
  categoryTypes: masterDataSelectors.categoryTypes(state),
  documentTypes: masterDataSelectors.documentTypes(state),
  getUploadProcessing: bankDetailsSelectors.getUploadProcessing(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(Responsive);
